var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShapePolygon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66949 6.03705C7.20132 6.18596 7.51174 6.73781 7.36283 7.26964L4.56283 17.2696C4.41392 17.8015 3.86206 18.1119 3.33023 17.963C2.7984 17.8141 2.48799 17.2622 2.6369 16.7304L5.4369 6.73038C5.58581 6.19855 6.13766 5.88813 6.66949 6.03705Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 19C4 18.4477 4.44772 18 5 18H19C19.5523 18 20 18.4477 20 19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3582 6.06023C17.8773 5.8715 18.451 6.13925 18.6398 6.65829L22.2398 16.5583C22.4285 17.0773 22.1608 17.6511 21.6417 17.8398C21.1227 18.0286 20.5489 17.7608 20.3602 17.2418L16.7602 7.34177C16.5714 6.82274 16.8392 6.24897 17.3582 6.06023Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5C8 4.44772 8.44772 4 9 4H15C15.5523 4 16 4.44772 16 5C16 5.55228 15.5523 6 15 6H9C8.44772 6 8 5.55228 8 5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3C4 2.44772 4.44772 2 5 2H9C9.55228 2 10 2.44772 10 3V7C10 7.55228 9.55228 8 9 8H5C4.44772 8 4 7.55228 4 7V3ZM6 4V6H8V4H6Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3C14 2.44772 14.4477 2 15 2H19C19.5523 2 20 2.44772 20 3V7C20 7.55228 19.5523 8 19 8H15C14.4477 8 14 7.55228 14 7V3ZM16 4V6H18V4H16Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 17C18 16.4477 18.4477 16 19 16H23C23.5523 16 24 16.4477 24 17V21C24 21.5523 23.5523 22 23 22H19C18.4477 22 18 21.5523 18 21V17ZM20 18V20H22V18H20Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 17C0 16.4477 0.447715 16 1 16H5C5.55228 16 6 16.4477 6 17V21C6 21.5523 5.55228 22 5 22H1C0.447715 22 0 21.5523 0 21V17ZM2 18V20H4V18H2Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapePolygon);
export default __webpack_public_path__ + "static/media/shape-polygon.d85526b76966921b0930d98476496c51.svg";
export { ForwardRef as ReactComponent };